import React, { useContext, useEffect, useRef, useState } from 'react';
import { LangContext } from '../../contexts/langContext';
import { SocialContext } from '../../contexts/socialContext';
import { StateContext } from '../../contexts/stateContext';
import { Button } from '../UiKit/Button';


export const parseGroupDescription = (desription) => {
  if (!desription) return {};
  if (typeof desription === 'object') return { ...desription };
  if (typeof desription !== 'string') return {};
  try {
    const parsed = JSON.parse(desription);
    if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
      return parsed;
    }
  } catch (e) {
    return { description: desription };
  }
  return { description: desription };
};


export const EditName = ({
  name = '',
  desription = '',
  fields = ['name'],
  placeholder = '',
  handleUpdate = () => void (0),
  onEditingChange = () => void (0)
}) => {

  const context = { ...useContext(SocialContext), ...useContext(StateContext), ...useContext(LangContext) };
  const $ui = context.$ui;

  const nameValue = name || '';
  const parsedDescription = parseGroupDescription(desription);
  const descriptionValue = parsedDescription.description || '';
  const imageValue = parsedDescription.image || '';
  const image2Value = parsedDescription.image2 || '';

  const [title, setTitle] = useState(nameValue);
  const [desriptionI, setDescription] = useState(descriptionValue);
  const [imageI, setImage] = useState(imageValue);
  const [image2I, setImage2] = useState(image2Value);
  const [isEditing, setIsEditing] = useState(false);
  const inputName = useRef(null);

  const hasDescriptionField = fields?.includes('description');
  const hasImageField = fields?.includes('image');
  const hasImage2Field = fields?.includes('image2');
  const hasSerializedFields = hasDescriptionField || hasImageField || hasImage2Field;

  const hasChanges =
    title !== nameValue
    || (hasDescriptionField && desriptionI !== descriptionValue)
    || (hasImageField && imageI !== imageValue)
    || (hasImage2Field && image2I !== image2Value);

  useEffect(() => {
    if (nameValue !== title) {
      setTitle(nameValue)
    }
  }, [nameValue])

  useEffect(() => {
    if (descriptionValue !== desriptionI) {
      setDescription(descriptionValue)
    }
  }, [descriptionValue])

  useEffect(() => {
    if (imageValue !== imageI) {
      setImage(imageValue)
    }
  }, [imageValue])

  useEffect(() => {
    if (image2Value !== image2I) {
      setImage2(image2Value)
    }
  }, [image2Value])

  useEffect(() => {
    setIsEditing(hasChanges);
    onEditingChange(hasChanges);
  }, [hasChanges, onEditingChange])

  const handleSave = () => {
    if (!hasChanges) {
      return;
    }

    let extra = desription;
    if (hasSerializedFields) {
      extra = JSON.stringify({
        ...parsedDescription,
        ...(hasDescriptionField ? { description: desriptionI } : {}),
        ...(hasImageField ? { image: imageI } : {}),
        ...(hasImage2Field ? { image2: image2I } : {}),
      });
    }

    handleUpdate(title, extra);
    setIsEditing(false);
    onEditingChange(false);
  };

  const isDisabled = !title || context.updatingAva || !hasChanges;


  return (<>
    <div className="x_name_container _fv">

      <div className="_f">
        <div className="x_calc_form0 _f100 _fstretch">

          <input
            ref={inputName}
            placeholder={placeholder ? placeholder : $ui('enter_name')}
            type="text"
            className="x_input x_input--bordered"
            onFocus={(e) => e.target.select()}
            onChange={(e) => setTitle(e.target.value)}
            value={title}
          />

          {/* <div className="x_input_right">
            <div className="x_input_action" onClick={() => {
              setTitle(data.name)
              inputName.current.focus()
            }}>
              <div className="t_icon t_icon--40">
                edit
              </div>
            </div>
          </div> */}

        </div>
        <Button
          className='x_name_save_button'
          icon={!context.updatingAva ? 'check' : 'pending'}
          disabled={isDisabled}
          inactive={!hasChanges}
          onClick={() =>
            !isDisabled && handleSave()
          }
        >
          {/* {!context.updatingAva && <div>
            {$ui('process_save')}
            </div>} */}
          {/* {context.updatingAva && <div>{$ui('process_saving')}...</div>} */}
        </Button>



      </div>

      {hasDescriptionField && <div className="x_input_container">
        <div className="x_input_label">
          {$ui('group_info_description')}
        </div>
        <textarea
        rows={3}
        cols={50}
        placeholder={''}
        type="text"
        className="x_input x_input--bordered"
        onFocus={(e) => e.target.select()}
        onChange={(e) => setDescription(e.target.value)}
        value={desriptionI}
      /></div>}


      {hasImageField && <div className="x_input_container">
        <div className="x_input_label">
          {$ui('group_info_image')}
        </div>
        <input
        type="text"
        className="x_input x_input--bordered"
        onFocus={(e) => e.target.select()}
        onChange={(e) => setImage(e.target.value)}
        value={imageI}
      /></div>}

      {hasImage2Field && <div className="x_input_container">
        <div className="x_input_label">
          {$ui('group_info_image2')}
        </div>
        <input
        type="text"
        className="x_input x_input--bordered"
        onFocus={(e) => e.target.select()}
        onChange={(e) => setImage2(e.target.value)}
        value={image2I}
      /></div>}


    </div>
  </>)
}
